module.exports = __webpack_public_path__ + "img/network.762225f6.png";